<template>
  <div class="quick-text-message">
    <div v-if="msgItem.systemType === 'enterRoom'">
      <span> {{ msgItem.nickname }}</span>
      <span> 已进入课堂</span>
    </div>
  </div>
</template>

<script>
import {
  USER_ROLE,
  USER_ROLE_NAME,
} from "@saas/live-sdk/src/services/utils/constants.js";
export default {
  name: "MsgText",
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    msgItem: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      USER_ROLE,
      USER_ROLE_NAME,
    };
  },
  methods: {
    // 判断一个字符串是否是链接
    isUrl(str) {
      return /^(https?|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/.test(
        str
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.quick-text-message {
  font-weight: 500;
  font-size: 12px;
  color: #ffffff;
  line-height: 15px;
  display: -webkit-box; /* 启用flexbox布局 */
  -webkit-box-orient: vertical; /* 垂直方向排列 */
  -webkit-line-clamp: 3; /* 限制显示三行 */
  overflow: hidden; /* 隐藏溢出内容 */
  text-overflow: ellipsis; /* 显示省略号 */
  word-break: break-word; /* 允许在长单词或URL内部换行 */

  a {
    color: #386bff;
  }
  .text-img {
    width: 17px; /* 调整表情图片大小 */
    height: 17px; /* 调整表情图片大小 */
    vertical-align: middle; /* 使图片与文字对齐 */
    display: inline-block; /* 确保图片是行内块，方便与文本对齐 */
  }
  .text-content {
    display: inline; /* 确保文本内容是行内元素 */
  }
  .role-tag {
    width: max-content;
    background: #052814;
    border-radius: 8px;
    height: 15px;
    padding: 0 4px;
    font-weight: 500;
    font-size: 11px;
    color: #17c964;
    line-height: 15px;
    display: inline-block; /* 确保角色标签是行内块 */
    margin-right: 4px; /* 添加一些右边距 */
    flex-shrink: 0; /* 防止被压缩 */
  }
  .nick-name {
    display: inline; /* 确保昵称是行内元素 */
  }
}
</style>
